import { ECE, TEACHER } from '@BUP/constants'
import { useContext } from 'react'
import { RoleContext } from '@BUP/contexts/RoleContext'
import SociogramECEPage from './sociogramECEPage'
import SociogramTeacherPage from './sociogramTeacherPage'

const SociogramPage = () => {
  const role = useContext(RoleContext)
  const roleType = role.type

  const pagesByRole = {
    [ECE]: SociogramECEPage,
    [TEACHER]: SociogramTeacherPage
  }

  const Component = pagesByRole[roleType]

  return Component ? <Component /> : null
}

export default SociogramPage
